const Previewer = ({ url }: any) => <embed src={url} height={800} width={500} />;
export default Previewer;
